export const roundDisplayPrice = (value) => {
  const num = parseFloat(value) || 0;
  return Math.ceil(num / 10) * 10;
};
